/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Data_Collected_S33_Item_1Inputs */

const es_privacy_policy_data_collected_s33_item_1 = /** @type {(inputs: Privacy_Policy_Data_Collected_S33_Item_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadatos de Archivo: nombre, tipo MIME, tamano, fechas, rutas`)
};

const en_privacy_policy_data_collected_s33_item_1 = /** @type {(inputs: Privacy_Policy_Data_Collected_S33_Item_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File Metadata: name, MIME type, size, dates, paths`)
};

/**
* | output |
* | --- |
* | "File Metadata: name, MIME type, size, dates, paths" |
*
* @param {Privacy_Policy_Data_Collected_S33_Item_1Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_data_collected_s33_item_1 = /** @type {((inputs?: Privacy_Policy_Data_Collected_S33_Item_1Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Data_Collected_S33_Item_1Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_data_collected_s33_item_1(inputs)
	return en_privacy_policy_data_collected_s33_item_1(inputs)
});
export { privacy_policy_data_collected_s33_item_1 as "privacy_policy.data_collected.s33_item_1" }